'use client';
import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Bell, Globe, Mail, Menu as MenuIcon, Phone, Share2, Sun, Wallet, X } from 'lucide-react';
import Image from 'next/image';
import { Avatar, Badge, Button, IconButton, Modal, Tab, Tabs, Tooltip } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { usePathname, useRouter } from 'next/navigation';
import { getSessionStorageItem } from '@/lib/storage';
import Link from 'next/link';
import FirstLoginModal from '../FirstLoginModal/FirstLoginModal';
import { FisrtloginStyle, StyleForRecieveCall, StyleForReviewCall } from '../ModalStyle/ModalStyle';
import { loginSuccess, setLoading } from '@/redux/slice/authSlice';
import apiCall from '@/lib/axios';
import NormalHeader from '../NormalHeader/NormalHeader';
import '@/app/css/ring.css';
import ShareModal from '../ShareModal/ShareModal';

export default function MobileHeader(color: any) {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };
  const data: any = getSessionStorageItem('data');

  const menuItems = [
    { id: 1, label: 'Home', icon: '/home.svg', link: '/', auth: false },
    {
      id: 2,
      label: 'About',
      icon: '/about.svg',
      link: '/staticpages/about-us',
      auth: false,
    },
    {
      id: 3,
      label: 'Work',
      icon: '/work.svg',
      link: '/worksection',
      auth: true,
    },
    {
      id: 4,
      label: 'Call History',
      icon: '/call.svg',
      link: '/products/callhistory',
      auth: true,
    },
    {
      id: 5,
      label: 'Messages',
      icon: '/messages.svg',
      link: '/products/messages',
      auth: true,
    },
    {
      id: 6,
      label: 'Topup',
      icon: '/topupSidebar.svg',
      link: '/topup',
      auth: true,
    },
    {
      id: 7,
      label: 'Earnings',
      icon: '/earning.svg',
      link: '/withdraw',
      auth: true,
    },
    {
      id: 8,
      label: 'Investment',
      icon: '/dollar-sign.svg',
      link: '/staticpages/investment',
      auth: false,
    },
    {
      id: 9,
      label: 'Newsroom',
      icon: '/newsroom.svg',
      link: '/staticpages/resources/newsroom',
      auth: false,
    },
    {
      id: 10,
      label: 'Refund Policy',
      icon: '/refund.svg',
      link: '/',
      auth: false,
    },
    {
      id: 11,
      label: 'Privacy Policy',
      icon: '/privacy.svg',
      link: '/staticpages/privacy',
      auth: false,
    },
    {
      id: 12,
      label: 'Term Of Use',
      icon: '/term.svg',
      link: '/staticpages/termofuse',
      auth: false,
    },
    {
      id: 13,
      label: 'Modern Slavery Statement',
      icon: '/modern.svg',
      link: '/staticpages/mss',
      auth: false,
    },
    {
      id: 14,
      label: 'Help and Support',
      icon: 'help.svg',
      link: '/staticpages/resources/contactus',
      auth: true,
    },
  ];

  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const _userFromState = useSelector((state: RootState) => state.auth.user);
  const router = useRouter();
  const handleProfileAvtarClick = () => {
    const WhoAmI = getSessionStorageItem('WhoAmI');
    if (WhoAmI === 'partial') {
      router.push('/profile');
      return;
    }
    router.push('/profile/pin');
  };

  const { accountType } = useSelector((state: RootState) => state.auth);
  const { newNotifications } = useSelector((state: any) => state.notification);

  const [openLoginModal, setOpenLoginModal] = React.useState(false);
  const handleLoginClose = () => setOpenLoginModal(false);
  const loginStyle = FisrtloginStyle;
  const handleCreateClick = () => {
    router.push('/partial-option-landing');
  };
  const handleOkClick = () => {
    localStorage.clear();
    sessionStorage.clear();
    router.push('/partial-option-landing');
  };

  const [isUserLoggedIn, setIsUserLoggedIn] = React.useState(false);
  const dispatch = useDispatch();
  React.useEffect(() => {
    const token: any = getSessionStorageItem('token');
    const accountType: any = getSessionStorageItem('WhoAmI');
    const user: any = getSessionStorageItem('user');
    const data: any = getSessionStorageItem('data');

    if (Boolean(token) && Boolean(accountType) && Boolean(user)) {
      dispatch(
        loginSuccess({
          token: token,
          user: user,
          isAuthenticated: true,
          accountType: accountType,
          data: data,
        }),
      );
      setIsUserLoggedIn(true);
    }
    dispatch(setLoading(false));
  }, []);

  const [anchorEl, _setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [isReviewModalOpened, _setIsReviewModalOpened] = React.useState(false);
  const [isCallRecievedModal, setIsCallRecievedModal] = React.useState(false);

  const [selectedWorkTab, setSelectedWorkTab]: any = React.useState(0);

  const handleWorkTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedWorkTab(newValue);
  };

  const [_activeWorkTab, setActiveWorkTab] = React.useState('calls');
  const [oldCalls, _setOldCalls] = React.useState([]);

  const openBell = Boolean(anchorEl);
  const handleClick = () => {
    setIsCallRecievedModal(true);
  };

  const getButtonColor = (variant?: string) => {
    switch (variant) {
      case 'consult':
        return 'bg-[#DBFFD6] hover:bg-green-100 border-[#2C9F1C]';
      case 'hire':
        return 'bg-[#FFD6D6] hover:bg-red-100 border-[#9F271C]';
      case 'interview':
        return 'bg-[#D7F6FF] hover:bg-blue-100 border-[#81C8F7]';
      case 'service':
        return 'bg-orange-50 hover:bg-orange-100 border-orange-200';
      default:
        return 'bg-[#FFEED6] hover:bg-gray-50 border-[#9F6B1C]';
    }
  };

  const [_roomData, setRoomData]: any = React.useState();
  const _getRoomsById = async (roomId: string) => {
    const response: any = await apiCall('GET', `/work/room/${roomId}`);
    setRoomData(response?.room);
    setLoading(false);
  };

  const _token: any = getSessionStorageItem('token');
  // const { callRequests }: any = useSelector((state: any) => state.call);

  const calls = useSelector((state: any) => state.call.callRequests);

  // Flatten calls for rendering
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  const callRequests = Object.values(calls || {}).flat();

  const handleAcceptCall = (requestId: any, type: string, query: string, roomId: string) => {
    router.push(`/worksection/room/${roomId}`);
    setTimeout(() => {
      setIsCallRecievedModal(false);
    }, 3000);
  };

  const pathname = usePathname();

  const noHeaderRoutes = [
    '/home/ongoingcall/user',
    '/topup/cards/',
    '/home/consult',
    '/home/service',
    '/worksection/room',
    '/worksection/pilot',
    '/worksection/subscribe',
  ]; // List of routes where only the logo should be shown

  // Normalize pathname, ensuring it starts with a slash for comparison
  const normalizedPathname = pathname.startsWith('/') ? pathname : `/${pathname}`;

  // Check if the pathname starts with one of the specified routes
  const isNoHeaderRoute = noHeaderRoutes.some((route) => normalizedPathname.startsWith(route));
  const [showFullMessage, setShowFullMessage] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const DrawerList = (
    <Box sx={{ width: 300 }} role="presentation">
      <div className="flex  justify-center pe-5 pt-4 w-full ">
        <Image src="/blueLogo.svg" alt="Expomore" height={120} width={120} />
      </div>
      <div onClick={toggleDrawer(false)} className="flex  justify-end pe-3 absolute top-4  w-full ">
        <X />
      </div>

      <List className="pb-0">
        {menuItems.map((item) => (
          <ListItem
            onClick={() => {
              if (item?.auth) {
                if (isUserLoggedIn && accountType !== 'partial') {
                  router.push(item?.link);
                } else {
                  setOpenLoginModal(true);
                }
              } else {
                router.push(item?.link);
              }
            }}
            key={item.id}
            disablePadding
          >
            <ListItemButton>
              <Image src={item.icon} alt="" width={18} height={20} />
              <ListItemText style={{ fontWeight: '500' }} className="ms-4" primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
        <div
          className="bg-[#EEEEFF] flex flex-col items-start ps-10 pt-2 mt-2"
          style={{ boxShadow: '0px -2px 4px 0px #00000040' }}
        >
          {' '}
          <ul>
            <li className="flex py-2 items-center">
              <Globe className="w-[18px] h-[18px] text-[#344054] " />
              <span className="ms-3 text-[##101828] text-[18px] font-normal ">English (UK)</span>
            </li>
            <li className="flex py-2 items-center">
              <Sun className="w-[18px] h-[18px] text-[#344054] " />
              <span className="ms-3 text-[##101828] text-[18px] font-normal ">Light Mode</span>
            </li>
            <li className="flex py-2 items-center">
              <Wallet className="w-[18px] h-[18px] text-[#344054] " />
              <span className="ms-3 text-[##101828] text-[18px] font-normal">Conversation Royalties</span>
            </li>
            <li className="flex py-2 items-center">
              <Mail className="h-[18px] w-[18px]" /> <span className="ms-3">support@JOBROOMS.com</span>
            </li>
            <li className="flex py-2 items-center">
              <button
                onClick={openModal}
                className="flex items-center mr-4 text-[11px] sm:text-[14px] text-black hover:text-gray-700"
              >
                <Share2 className="h-[18px] w-[18px]" /> <span className="ms-3 text-lg">Share JOBROOMS</span>
              </button>
            </li>
            <li className="flex justify-between mb-3 gap-3  py-2 items-center">
              <Link href="https://www.facebook.com/expomore" target="_blank">
                <Image src="/blackFacebook.svg" alt="Expomore" width={100} height={100} className="w-[18px] h-[18px]" />
              </Link>
              <Link href="https://www.instagram.com/expomore/" target="_blank">
                <Image src="/blackInsta.svg" alt="Expomore" width={100} height={100} className="w-[18px] h-[18px]" />
              </Link>
              <Link href="https://x.com/ExpomoreGlobal" target="_blank">
                <Image src="/blackTwitter.svg" alt="Expomore" width={100} height={100} className="w-[18px] h-[18px]" />
              </Link>
              <Link href="https://www.linkedin.com/company/ExpomoreGlobal" target="_blank">
                <Image src="/blackLinkedin.svg" alt="Expomore" width={100} height={100} className="w-[18px] h-[18px]" />
              </Link>
              <Link href="https://snapchat.com/t/ILxbhbeE" target="_blank">
                <Image src="/blackSnapchat.svg" alt="Expomore" width={100} height={100} className="w-[18px] h-[18px]" />
              </Link>
              <Link href="http://tiktok.com/@ExpomoreGlobal" target="_blank">
                <Image src="/blackTiktok.svg" alt="Expomore" width={100} height={100} className="w-[18px] h-[18px]" />
              </Link>
              <Link href="https://www.youtube.com/@Expomore" target="_blank">
                <Image src="/blackYoutube.svg" alt="Expomore" width={100} height={100} className="w-[18px] h-[18px]" />
              </Link>
            </li>
          </ul>
        </div>
      </List>
      <Divider />
    </Box>
  );

  React.useEffect(() => {
    if (open) {
      setOpen(false); // Auto close drawer when route changes
    }
  }, [pathname]);

  return (
    <>
      <ShareModal isOpen={isModalOpen} onClose={closeModal} />
      {!isNoHeaderRoute && (
        <div className="py-1 flex items-center justify-between w-full px-4 z-[99]">
          {isUserLoggedIn ? (
            <Modal
              open={openLoginModal}
              onClose={handleLoginClose}
              className="border-0"
              aria-labelledby="keep-mounted-modal-title"
              aria-describedby="keep-mounted-modal-description"
              disableEscapeKeyDown
            >
              <Box
                sx={{ ...loginStyle, border: 'none', outline: 'none' }}
                className=" px-6 py-2 mx-auto w-full max-w-[330px] sm:max-w-[500px] md:max-w-[500px] lg:max-w-[500px]"
              >
                <div className="w-full flex justify-center">
                  <div className="flex items-start w-full flex-col">
                    <h1 className="font-semibold text-[19px]  text-start text-black mt-3">
                      Personal or business account required
                    </h1>
                    <h2 className="text-sm  text-start text-black mt-1">
                      Please create or log in to your Personal or Business account to access this feature,
                    </h2>
                    <div className="flex w-full justify-end mt-3 mb-2">
                      <Button onClick={() => handleOkClick()} className=" bg-black ms-3 text-white px-6">
                        <span className="normal-case">Signup</span>
                      </Button>
                      <Button onClick={() => handleLoginClose()} className=" bg-black ms-3 text-white px-6">
                        <span className="capitalize">Cancel</span>
                      </Button>
                    </div>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : (
            <FirstLoginModal
              openLoginModal={openLoginModal}
              handleLoginClose={handleLoginClose}
              loginStyle={loginStyle}
              handleCreateClick={handleCreateClick}
              handleOkClick={handleOkClick}
            />
          )}

          {!isNoHeaderRoute && (
            <MenuIcon className={`${color?.color}`} onClick={toggleDrawer(true)} style={{ cursor: 'pointer' }}>
              Open Drawer
            </MenuIcon>
          )}
          <Drawer open={open} onClose={toggleDrawer(false)}>
            {DrawerList}
          </Drawer>

          {isAuthenticated && (
            <>
              {/* Review Modal */}
              <Modal
                open={isReviewModalOpened}
                onClose={() => {}}
                disableEscapeKeyDown
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
              >
                <Box
                  sx={{
                    ...StyleForReviewCall,
                    outline: 'none',
                  }}
                  className="w-full h-full"
                >
                  <NormalHeader />
                </Box>
              </Modal>

              <Modal
                open={isCallRecievedModal}
                onClose={() => setIsCallRecievedModal(false)}
                disableEscapeKeyDown
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
              >
                <div className="w-full relative h-full">
                  <Box
                    sx={{
                      ...StyleForRecieveCall,
                      outline: 'none',
                    }}
                    className=" px-2 py-2 h-[97%] overflow-hidden mx-auto w-full max-w-[90%] flex flex-col items-center"
                  >
                    <div className="w-[95%] relative h-full">
                      <Tabs
                        className="mt-4 w-full rounded-xl flex  justify-center items-center"
                        value={selectedWorkTab}
                        onChange={handleWorkTabChange}
                        variant="fullWidth"
                        sx={{
                          '& .MuiTabs-indicator': {
                            display: 'none',
                          },
                          '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: 600,
                            color: '#000',
                            backgroundColor: 'white',
                            px: 0,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          },
                          '& .Mui-selected': {
                            backgroundColor: '#F3F3F3',
                            color: '#007AFF',
                            padding: '0px 0px',
                            borderRadius: '10px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          },
                        }}
                      >
                        <Tab
                          onClick={() => setActiveWorkTab('calls')}
                          label={
                            <>
                              {callRequests?.length > 0 ? (
                                <Badge
                                  color="error"
                                  variant="dot"
                                  className="text-center"
                                  overlap="rectangular"
                                  sx={{
                                    '& .MuiBadge-dot': {
                                      top: 0,
                                      right: 0,
                                      padding: '6px',
                                      borderRadius: '50%',
                                      zIndex: '99',
                                    },
                                  }}
                                >
                                  Calls
                                </Badge>
                              ) : (
                                'Calls'
                              )}
                            </>
                          }
                          className="h-[20px] text-center text-[12px] sm:text-sm md:text-sm lg:text-md px-0 sm:px-1 md:px-2 lg:px-2 py-0 max-w-[250px] flex justify-center items-center"
                        />
                        <Tab
                          label={
                            <>
                              {newNotifications?.length > 0 ? (
                                <Badge
                                  color="error"
                                  variant="dot"
                                  className="text-center"
                                  overlap="rectangular"
                                  sx={{
                                    '& .MuiBadge-dot': {
                                      top: 0, // Adjusts the dot's position
                                      right: 0,
                                      padding: '6px',
                                      borderRadius: '50%',
                                      zIndex: '99',
                                    },
                                  }}
                                >
                                  Messages
                                </Badge>
                              ) : (
                                'Messages'
                              )}
                            </>
                          }
                          className="text-[12px] sm:text-sm md:text-sm lg:text-md px-1 sm:px-1 md:px-2 lg:px-2 py-0 max-w-[250px] flex justify-center items-center"
                          onClick={() => setActiveWorkTab('messages')}
                        />
                      </Tabs>

                      <div className="flex flex-col overflow-auto max-h-[80vh]  px-2 sm:px-8  md:px-10 lg:px-12 mt-3">
                        {selectedWorkTab === 0 && (
                          <>
                            <h1 className="text-xl font-semibold mt-5 text-[#878787]">New</h1>

                            {callRequests?.length > 0 ? (
                              <div className="flex flex-col w-full items-center">
                                {callRequests?.map((request: any, index: any) => (
                                  <button
                                    key={index}
                                    onClick={() =>
                                      handleAcceptCall(request.requestId, request.type, request.query, request.roomId)
                                    }
                                    className={`flex my-2 items-center gap-3 w-full min-w-[270px] p-3 sm:p-4 md:p-4 lg:p-4 lg:max-w-[556px] h-[85px] mx-auto rounded-lg border transition-all duration-200 ${getButtonColor(
                                      request?.type,
                                    )}`}
                                  >
                                    <Phone className="ring-vibrate sm:h-[30px] sm:w-[30px] md:h-[30px] md:w-[30px] lg:h-[30px] lg:w-[30px]" />
                                    <div className="flex-1">
                                      <h3 className="text-left text-[16px] font-semibold">
                                        {request?.type === 'consult'
                                          ? 'Consultation Call'
                                          : request?.type === 'hire'
                                            ? 'Hiring Call'
                                            : request?.type === 'Interview'
                                              ? 'Interview Call'
                                              : request?.type === 'request'
                                                ? 'Service Call'
                                                : 'Interview Call'}
                                      </h3>
                                      {request?.query != null && (
                                        <p className="text-left text-sm text-gray-600 mt-1">{request?.label}</p>
                                      )}
                                    </div>
                                  </button>
                                ))}
                              </div>
                            ) : (
                              <h2 className=" mt-5 text-start w-full h-[100px] flex  text-[#878787] ">Nothing here</h2>
                            )}
                          </>
                        )}

                        {selectedWorkTab === 1 && (
                          <>
                            <h1 className="text-xl font-semibold mt-5 text-[#878787]">New</h1>
                            {newNotifications?.length > 0 &&
                              newNotifications?.map((not: any) => (
                                <div
                                  className="w-full bg-white rounded-lg cursor-pointer  transition-shadow duration-300 ease-in-out flex items-center"
                                  key={not?.id}
                                >
                                  <div className="flex-grow">
                                    <div className=" py-4">
                                      <div
                                        className={
                                          not?.status === 'DENIED'
                                            ? 'mb-2 text-red-500 text-sm font-semibold'
                                            : 'mb-2 text-green-500 text-sm font-semibold'
                                        }
                                      >
                                        Status: {not?.status}
                                      </div>

                                      {/* <p className="text-gray-800 text-lg">{not?.message}</p> */}
                                      <div>
                                        <p className="text-gray-800 text-lg">
                                          {showFullMessage
                                            ? not?.message
                                            : `${not?.message?.slice(0, 107)}${not?.message?.length > 100 ? '' : '.'}`}
                                          {not?.message?.length > 100 && (
                                            <button
                                              onClick={() => setShowFullMessage(!showFullMessage)}
                                              className="text-blue-500 ms-1"
                                            >
                                              {showFullMessage ? 'read less.' : 'read more.'}
                                            </button>
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            {callRequests?.length > 0 ? (
                              <h2 className=" text-start mt-5 w-full h-[100px] flex  text-[#878787] ">Nothing here</h2>
                            ) : (
                              <h2 className=" text-start mt-5 w-full h-[100px] flex  text-[#878787] ">Nothing here</h2>
                            )}
                            <h1 className="text-xl font-semibold text-[#878787]">This week</h1>
                            {oldCalls?.length < 1 ? (
                              <h2 className=" text-start h-[100px] w-full text-[#878787] mt-5">Nothing here</h2>
                            ) : null}
                            <h1 className="text-xl font-semibold text-[#878787]">Earlier</h1>
                            {oldCalls?.length < 1 ? (
                              <h2 className=" text-start w-full h-[100px] text-[#878787] mt-5">Nothing here</h2>
                            ) : null}
                          </>
                        )}
                      </div>
                    </div>
                  </Box>
                  <div className="flex items-center justify-center absolute cursor-pointer bg-white h-6 w-6 rounded-full border-2 border-gray-300 top-2 end-2 sm:top-1 sm:end-2 md:top-2 md:end-5  lg:top-2 lg:end-7">
                    <X
                      onClick={() => {
                        setIsCallRecievedModal(false);
                      }}
                      className="transition-transform text-gray-500 duration-300 ease-in-out hover:rotate-180"
                    />
                  </div>
                </div>
              </Modal>
              {!isNoHeaderRoute && (
                <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                  <Tooltip title="Notifications">
                    <IconButton
                      onClick={handleClick}
                      sx={{ ml: 2 }}
                      aria-controls={openBell ? 'account-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={openBell ? 'true' : undefined}
                      size="small"
                    >
                      <Badge
                        color="error"
                        badgeContent={
                          (callRequests !== null && callRequests !== undefined ? callRequests.length : 0) +
                          (newNotifications !== null && newNotifications !== undefined ? newNotifications.length : 0)
                        }
                        max={999}
                      >
                        <Bell className="text-black h-[20px] w-[20px] " />
                      </Badge>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Account settings">
                    {data?.profilePicture !== undefined && data?.profilePicture !== null ? (
                      <Image
                        className="rounded-[50%] cursor-pointer w-[35px] h-[35px] ms-3 object-cover"
                        src={
                          typeof data?.profilePicture === 'string' && data.profilePicture.trim() !== ''
                            ? data.profilePicture
                            : '/profile-main.png'
                        }
                        height={100}
                        onClick={handleProfileAvtarClick}
                        width={100}
                        alt="Profile"
                      />
                    ) : (
                      <IconButton onClick={handleProfileAvtarClick} size="small" sx={{ ml: 1 }}>
                        <Avatar className="bg-[#191566] capitalize" sx={{ width: 28, height: 28 }}>
                          {data?.fullName?.charAt(0)}
                        </Avatar>
                      </IconButton>
                    )}
                  </Tooltip>
                </Box>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
}
